module.exports = __webpack_public_path__ + "static/dnanexus-logo-5e65abb0e24d924ce0e3573c36791767.png";